export const INVALID_FAX_NUMBER_ERROR = 'Fax number must be a valid 10 or 11 digit US phone number';

export const DELIVERY_METHOD_LABELS = {
  email: 'Email',
  fax: 'Fax',
  link: 'Link',
};

export const FAX_STATUS_LABELS = {
  queued: 'Queued',
  sending: 'Sending',
  submitted: 'Submitted',
  in_progress: 'In Progress',
  delivered: 'Delivered',
  failed: 'Failed',
};

export const NON_RESENDABLE_FAX_STATUSES = ['queued', 'sending', 'submitted', 'in_progress', 'delivered'];
export const FAX_RESEND_LIMIT = 5;

export const normalizeFaxNumber = (value) => {
  const trimmed = value?.trim() || '';
  if (!trimmed) return null;

  if (/^\+1\d{10}$/.test(trimmed)) {
    return trimmed;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  return null;
};

export const isActionablePendingInvitation = (invitation) => (
  invitation?.status === 'pending'
  && (!invitation.expires_at || new Date(invitation.expires_at).getTime() > Date.now())
);

export const canResendInvitation = (invitation, { faxDeliveryAvailable = true } = {}) => {
  if (!invitation) return false;
  if (typeof invitation.can_resend === 'boolean') return invitation.can_resend;
  if (!isActionablePendingInvitation(invitation)) return false;
  if (invitation.delivery_method === 'email') return true;
  if (invitation.delivery_method !== 'fax') return false;

  return faxDeliveryAvailable
    && Number(invitation.send_count || 0) < FAX_RESEND_LIMIT
    && !NON_RESENDABLE_FAX_STATUSES.includes(invitation.fax_status);
};
